import React from 'react';

import { NavLink } from 'react-router-dom';
import MyPage from "../../../src/MyPage";
import SubTabsDashboard from "../../../src/SubTabsDashboard";
import Profile from "../Profile"
import '../../App.css';
import '../../styles.css';
  function Dashboard() {
    return (
      <div className="scrollable-container">
        <MyPage />
        <SubTabsDashboard />
      </div>
    );
  }
export default Dashboard;